import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  TextField,
  IconButton,
  List,
  ListItem,
  Paper,
  Avatar,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import PersonIcon from "@mui/icons-material/Person";
import AvatarPng from "../assets/robot.png";
import { useClientContext } from "../context/ClientContext";
import { useCenterPanelContext } from "../context/CenterPanelContext";
import { mockChatData2, mockChatData3, mockChatData4 } from "../assets/mockDataAgentic";

// Mock chat data
const mockChatData = [
  {
    id: 1,
    type: "answer",
    title: "Orchestrator",
    text: "Welcome to AI Refinery!",
    text2: "Hi! I'm here to help you with your business intelligence analysis.",
  },
];

function CustomChatbot({ height, selectedItem }) {
  const [messages, setMessages] = useState(mockChatData);
  const [input, setInput] = useState("");
  const { clientGroup } = useClientContext();
  const [mockResponseIndex, setMockResponseIndex] = useState(0);
  const chatContainerRef = useRef(null);
  const isFirstRender = useRef(true);
  const { data, setData, marketOverviewData, setMarketOverviewData,
    section2Data, setSection2Data,
    section3Data, setSection3Data,
    section4Data, setSection4Data,
  } =
    useCenterPanelContext();

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (selectedItem?.title && selectedItem.id === "conversation-strategy") {
      const newQuestion = {
        id: messages.length + 1,
        type: "question",
        text: selectedItem.description,
      };

      setMessages((prev) => [...prev, newQuestion]);

      const responseData = mockChatData2[selectedItem.id];

      // responseData.forEach((mockResponse, index) => {
      //   setTimeout(() => {
      //     setMessages(prev => [...prev, {
      //       ...mockResponse,
      //       id: prev.length + 1
      //     }]);
      //     //console.log('mockResponse.data', mockResponse.data);
      //     setData(prev => ({...prev, ...mockResponse.data}));
      //   }, (index + 1) * 2000);
      // });

      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

      const processResponses = async () => {
        for (const [index, mockResponse] of responseData.entries()) {
          await delay((index + 1) * 1000); // Wait before processing the next message

          setMessages((prev) => [
            ...prev,
            {
              ...mockResponse,
              id: prev.length + 1,
            },
          ]);

          if (mockResponse.data && Object.keys(mockResponse.data).length > 0) {
            await delay(2000); // Wait 5 seconds before setting data
          }

          setData((prev) => ({ ...prev, ...mockResponse.data }));
        }
      };

      processResponses();
    }

    if (selectedItem?.title && selectedItem.id === "cro-overview") {
      const newQuestion = {
        id: messages.length + 1,
        type: "question",
        text: selectedItem.description,
      };

      setMessages((prev) => [...prev, newQuestion]);

      const responseData = mockChatData3[selectedItem.id];

      responseData.forEach((mockResponse, index) => {
        setTimeout(() => {
          setMessages((prev) => [
            ...prev,
            {
              ...mockResponse,
              id: prev.length + 1,
            },
          ]);
          //console.log('mockResponse.data', mockResponse.data);
          //setMarketOverviewData((prev) => ({ ...prev, ...mockResponse.data }));
          setSection2Data((prev) => ({ ...prev, ...mockResponse.data }));
        }, (index + 1) * 2000);
      });
    }
    //console.log("selectedItem", selectedItem);
    if (selectedItem?.title && selectedItem.id === "company-research") {
      const newQuestion = {
        id: messages.length + 1,
        type: "question",
        text: selectedItem.description,
      };

      setMessages((prev) => [...prev, newQuestion]);

      const responseData = mockChatData4[selectedItem.id];

      responseData.forEach((mockResponse, index) => {
        setTimeout(() => {
          setMessages((prev) => [
            ...prev,
            {
              ...mockResponse,
              id: prev.length + 1,
            },
          ]);
          //console.log('mockResponse.data', mockResponse.data);
          //setMarketOverviewData((prev) => ({ ...prev, ...mockResponse.data }));
          setSection3Data((prev) => ({ ...prev, ...mockResponse.data }));
        }, (index + 1) * 2000);
      });
    }
  }, [selectedItem]);

  const handleSend = () => {
    if (input.trim()) {
      const newMessages = [
        ...messages,
        {
          id: messages.length + 1,
          type: "question",
          text: input,
        },
      ];
      setMessages(newMessages);
      setInput("");

      setTimeout(() => {
        const responseData = mockChatData2[selectedItem.id];
        const mockResponse = responseData[mockResponseIndex];
        if (mockResponse) {
          setMessages((prev) => [
            ...prev,
            {
              ...mockResponse,
              id: prev.length + 1,
            },
          ]);
          setMockResponseIndex((mockResponseIndex + 1) % responseData.length);
        }
      }, 1000);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSend();
    }
  };

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        p: 1,
        borderRadius: "8px",
        boxShadow: 2,
        height: height || "88vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="flex justify-between mb-1">
        <span className="text-sm font-semibold" style={{ color: "#6B7280" }}>
          <i>Agent Command</i>
        </span>
      </div>

      <Paper
        ref={chatContainerRef}
        sx={{
          flex: 1,
          overflowY: "auto",
          mb: 2,
          backgroundColor: "#f9f9f9",
          borderRadius: "8px",
        }}
      >
        <List>
          {messages.map((message) => (
            <ListItem
              key={message.id}
              sx={{
                justifyContent:
                  message.type === "question" ? "flex-end" : "flex-start",
              }}
            >
              {message.type === "question" ? (
                <Paper
                  sx={{
                    p: 1,
                    maxWidth: "80%",
                    textAlign: "right",
                    backgroundColor: "#E6F5F6",
                    borderRadius: "8px",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  {message.text} Client Name: {clientGroup}
                  <Avatar sx={{ width: 24, height: 24, ml: 1 }}>
                    <PersonIcon />
                  </Avatar>
                </Paper>
              ) : (
                <Paper
                  sx={{
                    p: 1,
                    backgroundColor: "light grey",
                    borderRadius: "8px",
                    fontSize: "12px",
                    whiteSpace: "pre-wrap",
                    maxWidth: "80%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <div className="flex items-center">
                    <Avatar
                      sx={{ width: 24, height: 24, mr: 1, bgcolor: "#E6F5F6" }}
                    >
                      {message.title ? (
                        <div style={{ fontSize: "12px" }} className="text-main">
                          {message.title
                            .split(" ")
                            .map((word) => word[0])
                            .join("")}
                        </div>
                      ) : (
                        "AI"
                      )}
                    </Avatar>
                    {message.title && (
                      <div style={{ fontWeight: "bold" }}>{message.title}</div>
                    )}
                  </div>
                  <div>
                    {message.text}
                    {message.text2}
                  </div>
                </Paper>
              )}
            </ListItem>
          ))}
        </List>
      </Paper>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Enter a prompt..."
          size="small"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={handleKeyPress}
          sx={{
            borderRadius: "25px",
            backgroundColor: "#fff",
            ".MuiOutlinedInput-root": {
              borderRadius: "25px",
              fontSize: "12px",
            },
          }}
        />
        <IconButton
          color="primary"
          onClick={handleSend}
          sx={{ ml: 1 }}
          disabled={input.trim().length < 1}
        >
          <SendIcon />
        </IconButton>
      </Box>
    </Box>
  );
}

export default CustomChatbot;
